import Layout from '@/components/Layout'
import Welcome from '@/components/Welcome'
import Login from '@/components/auth/Login'
import UpdateProfile from '@/components/auth/UpdateProfile'
import App from '@/components/App'
import App2 from '@/components/App2'
import NotFound from '@/components/errors/404'
import Firestore from '@/components/Firestore'
import Solarspot from '@/components/Solarspot'

import Vue from 'vue'

const routes = [{
    path: '/',
    component: Layout,
    children: [{
            path: '/',
            component: Welcome,
            name: 'Welcome'
        },
        {
            path: '/login',
            component: Login,
            name: 'login'
        },
        {
            path: '/update-profile',
            component: UpdateProfile,
            name: 'Profile Update',
            meta: {
                auth: true
            }
        },
        {
            path: '/kontakt',
            component: App2,
            name: 'Realtime Database2',
            meta: {
                auth: true
            }
        },
        {
            path: '/realtime-database',
            component: App,
            name: 'Realtime Database',
            meta: {
                auth: true
            }
        },
        {
            path: '/firestore',
            component: Firestore,
            name: 'Cloud Firestore',
            meta: {
                auth: true
            }
        },
               {
            path: '/solarspot',
            component: Solarspot,
            name: 'Solarspot',
            meta: {
                auth: true
            }
        },
        {
            path: '*',
            component: NotFound
        }
    ]
}]

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js